import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { Stack, Typography, Button } from "@mui/material"
import mainLogo from "../../../assets/image/home/main-logo-large.svg"
import aiViralImage from "../../../assets/image/home/hero-ai-viral.png"
import styles from './Hero.module.scss'

export const Hero = ({ handleCreateNewProject }) => {
    const languageStrs = useSelector((store) => store.editdata.languageStrs)

    return (
        <Stack alignItems={"center"}>
            <img width={"40%"} src={mainLogo} />

            <Typography
                variant="h1"
                align="center"
                sx={{
                    fontSize: { xs: '2.5rem', sm: '3rem', md: '4rem', lg: '5rem', xl: '7rem' },
                    fontWeight: 700,
                    marginBlock: '0.3rem',
                }}
            >
                {languageStrs.your_online}<br />{languageStrs.ai_video_editor}
            </Typography>

            <Typography
                variant="h2"
                sx={{
                    fontSize: { xs: '1rem', sm: '1.5rem', md: '2rem', lg: '3rem', xl: '3.5rem' },
                    fontWeight: 200,
                    marginBottom: '1rem',
                }}
            >
                {languageStrs.one_click_post_production}
            </Typography>

            <Button
                className="upscaleTransition"
                onClick={handleCreateNewProject}
                sx={{
                    padding: '0 2rem',
                    borderRadius: 0,
                    flexDirection: 'column',
                    background: "linear-gradient(to right,#CD3235, #AA26BE)",
                    marginBottom: '1.5rem',
                }}
            >
                <Typography
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.5rem', md: '2rem', lg: '3rem', xl: '3.5rem' },
                        fontWeight: 700,
                        color: '#E0E0E0'
                    }}
                >
                    {languageStrs.try_for_free}
                </Typography>
                <Typography sx={{
                    textTransform: "lowercase",
                    fontSize: { xs: '0.6rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                    fontWeight: 300,
                    color: '#E0E0E0'
                }}>
                    ({languageStrs.no_sign_up_required})
                </Typography>

            </Button>

            <img width={"70%"} src={aiViralImage} />

        </Stack>
    )
}

export default Hero